<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：中华人民共和国住房和城乡建设部网站）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入遗产地/地区"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-date-picker
              popper-class="timeclass"
              v-model="yearDate"
              type="year"
              class="sele"
              format="yyyy"
              @change="sele"
              placeholder="选择年份"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="heritageName"
              label="遗产地"
              min-width="440px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="includedYear"
              label="列入年份"
              min-width="250px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="location"
              label="地区"
              min-width="300px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_CULTURAL_HERITAGE_LIST,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "",
        // 浏览次数
        num: "2",
      },
      // 年份
      yearDate: null,
      // 转化后只存在年份的年份
      yearDateTwo: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      pagesize: 20,
    };
  },
  computed: {},
  methods: {
    getList() {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pagesize,
        keywords: this.searchOn,
        includedYear: this.yearDateTwo,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http
        .get(Url + URL_CULTURAL_HERITAGE_LIST, { params })
        .then((resp) => {
          if (resp.status === 200) {
            this.legalForms = resp.data.rows;
            this.total = resp.data.total;
          }
        });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataWorldHeritage"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataWorldHeritage",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] = "DataWorldHeritage";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    //年份
    sele(yearDate) {
      if (yearDate) {
        const time = new Date(this.yearDate);
        this.yearDateTwo = time.getFullYear();
      } else {
        this.yearDateTwo = null;
      }
      this.getList();
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.yearDate = null;
      this.yearDateTwo = null;
      this.currentPage = 1;
      this.pagesize = 20;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
  mounted() {
    this.regulations.laws = this.$route.query.title;
    this.getList();
    this.getNumberViews();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
/deep/ .el-breadcrumb {
  font-size: 16px;
}
/deep/ .el-input--suffix .el-input__inner {
  font-size: 16px;
}
/deep/ .el-button {
  font-size: 16px !important;
}
.refresh {
  height: 100%;
}
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.ipt {
  margin-top: 10px;
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.sele {
  width: 220px;
  margin: 10px 0;
}
.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  // margin-bottom: 10px;
  align-items: center;
}
/deep/.el-year-table td .cell:hover,
.el-year-table td.current:not(.disabled) .cell {
  color: #b71c1c;
}
</style>